module.exports = __webpack_public_path__ + "static/media/31-1.11f2486d.mp3";